// @flow
import Config from 'config';

/* eslint-disable import/prefer-default-export */
export function entityURLForCohort() {
  // In future when the URL is cohort-specific, pass in cohortID and add more custom logic.
  return Config.GAMMA_URL;
}

export const COHORT_PAX_TYPES = [
  {
    name: 'Passenger',
    value: 0,
  },
  {
    name: 'Charice',
    value: 1,
  },
];



/** WEBPACK FOOTER **
 ** ./src/js/utils/cohort-utils.js
 **/